import { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import api from '@/lib/api'
import AuthCard from '@/components/AuthCard'

export default function ForgotPassword() {
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState(searchParams.get('email') || '')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    try {
      await api.post('/users/forgot-password', { email, user_type: 'marketer' })
      setSent(true)
    } catch (err: any) {
      setError(err.response?.data?.error || "Couldn't send the reset link. Please try again.")
    } finally {
      setBusy(false)
    }
  }

  if (sent) {
    return (
      <AuthCard title="Check your email">
        <p className="text-center text-[#4B5563]">
          If there's an account for {email}, we've sent a link to set a new password. It works for
          an hour.
        </p>
        <Link
          to="/signin"
          className="mt-6 block text-center text-sm font-medium text-[#3F7A0A] underline underline-offset-2"
        >
          Back to sign in
        </Link>
      </AuthCard>
    )
  }

  return (
    <AuthCard title="Reset your password">
      <p className="mb-4 text-center text-[#4B5563]">
        Enter your email and we'll send you a link to set a new password.
      </p>
      <form onSubmit={submit} className="space-y-4">
        {error && <p className="text-sm text-red-400">{error}</p>}
        <input
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@brand.com"
          className="h-12 w-full rounded-xl border border-[#D8DEE4] px-4 text-[#0F172A] outline-none focus:border-[#3F7A0A]"
        />
        <button
          type="submit"
          disabled={busy}
          className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[#C0FD72] font-medium text-black hover:bg-[#a8e45a] disabled:opacity-60"
        >
          {busy && <Loader2 className="h-5 w-5 animate-spin" />}
          Send reset link
        </button>
      </form>
      <Link
        to="/signin"
        className="mt-4 block text-center text-sm font-medium text-[#3F7A0A] underline underline-offset-2"
      >
        Back to sign in
      </Link>
    </AuthCard>
  )
}
